export default __webpack_public_path__ + "static/media/logoNeitorVet.228894c7.png";